import React from 'react'
import {
  FormDashboardInput as Input,
  FormDashboardLabel as Label,
  Button,
  PinPointInput,
  FormRow
} from '../../../components'
import Select from 'react-select'
import { useViewport, viewportBreakpoint } from '../../../utils'

const LocationPopup = ({onClose}) => {
  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet

  const handleClose = (e) => {
    e.preventDefault()
    e.stopPropagation()

    onClose(false)
  }

  return (
    <div
      className="fixed left-0 top-0 w-full h-screen flex justify-center items-center overflow-y-auto"
      style={{zIndex: 900, background: 'rgba(0, 0, 0, 0.75)'}}
      onClick={handleClose}
    >
      <div className="container mx-auto pt-40 lg:pt-0 my-10 lg:my-0" onClick={(e) => e.stopPropagation()}>
        <div className="w-full lg:w-10/12 mx-auto px-4 py-5 lg:px-0 lg:py-16 bg-white rounded">
          <div className="lg:w-3/5 mx-auto">
            <h1 className="text-lg lg:text-2xl text-center lg:text-left font-bold font-primary mb-5 lg:mb-10">Add New Location</h1>
            <div className="flex flex-wrap -mx-4 mb-5 lg:mb-8">
              <div className="w-full lg:w-1/2 px-4 mb-5 lg:mb-0">
                <Label>Province</Label>
                <Select className="text-sm" options={[]} placeholder="Choose Province" />
              </div>
              <div className="w-full lg:w-1/2 px-4">
                <Label>City</Label>
                <Select className="text-sm" options={[]} placeholder="Choose City" />
              </div>
            </div>
            <FormRow>
              <Label>Address (Optional)</Label>
              <Input className="w-full" defaultValue="Jl. Cijagra No.48, Cijagra, Lengkong, Kota Bandung 40265"/>
            </FormRow>
            <FormRow last>
              <Label>Pin Point (Optional)</Label>
              <PinPointInput />
            </FormRow>
            <div className="flex flex-wrap items-center">
              <Button
                style={{maxWidth: isMobile ? '100%' : '197px'}}
                thin={isMobile ? true : false}
                className="mb-5 lg:mb-0"
                onClick={handleClose}
              >
                Save
              </Button>
              <div
                className="text-center lg:text-left w-full lg:w-auto text-xs lg:text-sm text-gray-444 underline lg:ml-8"
                onClick={handleClose}
              >
                Cancel
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { LocationPopup }